import React, { useEffect, useState } from "react";
import "./SpcIdentifies.css";
import axios from "axios";

function SpcIdentifies() {
  const [species, setSpecies] = useState([]);
  const [selectedSpecies, setSelectedSpecies] = useState(null);

  // Fetch species data when the component mounts
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/scplist`)
      .then((response) => {
        setSpecies(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the species data!", error);
      });
  }, []);

  // Function to open the modal with the selected species item
  const openModal = (item) => {
    setSelectedSpecies(item);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedSpecies(null);
  };

  return (
    <div className="spc">
      <h1>Recent Identified Species</h1>
      <div className="species-grid">
        {species.map((item) => {
          const imgSrc = `${process.env.REACT_APP_API_URL}/static/identified_pics/${item.id}.jpg`;
          return (
            <div
              key={item.id}
              className="species-item"
              onClick={() => openModal(item)}
            >
              <img
                src={imgSrc}
                alt={item.species}
                onError={(e) => {
                  console.error(`Failed to load image: ${imgSrc}`);
                  e.target.src = "fallback-image.jpg";
                }}
              />
              <div className="species-info">
                <p className="spc-title">{item.species}</p>
                <p className="spc-user">
                  User: {item.user ? item.user : "Guest"}
                </p>
                <p className="spc-user">{item.datetime}+6</p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Modal for selected species item */}
      {selectedSpecies && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              ×
            </button>
            <img
              src={`${process.env.REACT_APP_API_URL}/static/identified_pics/${selectedSpecies.id}.jpg`}
              alt={selectedSpecies.species}
            />
            <div className="modal-info">
              <h2>{selectedSpecies.species}</h2>
              <p>
                User: {selectedSpecies.user ? selectedSpecies.user : "Guest"}
              </p>
              <p>Date: {selectedSpecies.datetime}+6</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SpcIdentifies;
